import {
    MANAGER_UPDATE_DETAIL_FAIL,
    MANAGER_UPDATE_DETAIL_REQUEST,
    MANAGER_UPDATE_DETAIL_SUCCESS,
    MANAGER_CHANGE_PASSWORD_FAIL,
    MANAGER_CHANGE_PASSWORD_REQUEST,
    MANAGER_CHANGE_PASSWORD_SUCCESS,
    MANAGER_UPDATE_IMAGE_FAIL,
    MANAGER_UPDATE_IMAGE_REQUEST,
    MANAGER_UPDATE_IMAGE_SUCCESS,
  } from "../../types/manager/authTypes";

export const ManagerUpdateDetailReducers = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case MANAGER_UPDATE_DETAIL_REQUEST:
        return {
          ...state,
          detailLoading: true,
        };
      case MANAGER_UPDATE_DETAIL_SUCCESS:
        return {
          ...state,
          detailLoading: false,
          ManagerDetailInfo: payload,
          detailError: '',
        };
      case MANAGER_UPDATE_DETAIL_FAIL:
        return {
          ...state,
          detailLoading: false,
          ManagerDetailInfo: null,
          detailError: payload,
        };
      default:
        return state;
    }
  };
  
  export const ManagerChangePasswordReducers = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case MANAGER_CHANGE_PASSWORD_REQUEST:
        return {
          ...state,
          UpdatePassloading: true,
        };
      case MANAGER_CHANGE_PASSWORD_SUCCESS:
        return {
          ...state,
          UpdatePassLoading: false,
          ManagerUpdatePassInfo: payload,
          UpdatePassError: '',
        };
      case MANAGER_CHANGE_PASSWORD_FAIL:
        return {
          ...state,
          UpdatePassLoading: false,
          ManagerUpdatePassInfo: null,
          UpdatePassError: payload,
        };
      default:
        return state;
    }
  };
  
  export const ManagerChangeImageReducers = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case MANAGER_UPDATE_IMAGE_REQUEST:
        return {
          ...state,
          updateImageLoading: true,
        };
      case MANAGER_UPDATE_IMAGE_SUCCESS:
        return {
          ...state,
          updateImageLoading: false,
          ManagerUpdateImageInfo: payload,
          updateImageError: '',
        };
      case MANAGER_UPDATE_IMAGE_FAIL:
        return {
          ...state,
          updateImageLoading: false,
          ManagerUpdateImageInfo: null,
          updateImageError: payload,
        };
      default:
        return state;
    }
  };